module.exports = __webpack_public_path__ + "static/img/product-l30.95cbd823.png";